import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-get-in-touch-ribbon',
  templateUrl: './get-in-touch-ribbon.component.html',
  styleUrls: ['./get-in-touch-ribbon.component.css']
})
export class GetInTouchRibbonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
